import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const {
  FiExternalLink,
  FiBook,
  FiAward,
  FiFileText,
  FiCreditCard,
  FiArrowRight,
  FiCalendar,
  FiChevronDown,
  FiHelpCircle,
} = FiIcons;

const articles = [
  {
    title:
      "RNCP37275 : comment financer sa formation sans se tromper",
    date: "23/03/2026",
    excerpt:
      "Devenir formateur professionnel d'adultes via la certification RNCP37275 représente un investissement stratégique. Plusieurs dispositifs de financement existent, à condition de bien les mobiliser.",
    link: "/ressources/rncp37275-financer-formation",
  },
  {
    title:
      "RNCP37275 : le grand écart des prix sur le marché de la formation de formateurs",
    date: "18/03/2026",
    excerpt:
      "La certification RNCP37275 s'impose comme un standard incontournable. Mais derrière cette reconnaissance commune, les prix affichés varient fortement, révélant un marché à plusieurs vitesses.",
    link: "/ressources/rncp37275-grand-ecart-prix-formation",
  },
  {
    title:
      "Vers une nouvelle génération de formateurs",
    date: "11/03/2026",
    excerpt:
      "Le titre RNCP37275 marque un basculement : celui d'un métier longtemps informel vers une profession plus lisible, outillée, et désormais structurée autour d'un référentiel national.",
    link: "/ressources/nouvelle-generation-formateurs",
  },
  {
    title:
      "Genèse et enjeux du titre RNCP37275 dédié à la formation professionnelle",
    date: "04/03/2026",
    excerpt:
      "D'où vient le titre RNCP37275 et pourquoi a-t-il pris une telle importance dans l'écosystème français de la formation ? Retour sur la genèse d'un titre devenu structurant.",
    link: "/ressources/genese-enjeux-titre-rncp37275",
  },
  {
    title:
      "Le titre FPA RNCP37275 : pas obligatoire aujourd'hui, mais bientôt quasi indispensable",
    date: "13/02/2026",
    excerpt:
      "Le Titre professionnel Formateur Professionnel d'Adultes n'est pas une obligation légale, mais il devient progressivement un standard sur un marché où la qualité et les contrôles se renforcent nettement.",
    link: "/ressources/titre-fpa-rncp37275",
  },
];

const categories = [
  {
    title: "Le métier formateur d'adultes",
    icon: FiBook,
    color: "bg-blue-100 text-blue-600",
    liens: [
      {
        titre: "Fiche métier Onisep",
        url: "https://www.onisep.fr/ressources/univers-metier/metiers/formateur-formatrice-d-adultes",
      },
      {
        titre: "Réferenciel emploi activités compétences",
        url: "/REAC_FPA_V07_21122022.pdf",
      },
      {
        titre: "Réferenciel d'évaluation du titre professionnel",
        url: "/REV2_FPA_V07_21122022.pdf",
      },
    ],
  },
  {
    title: "Certification officielle RNCP37275",
    icon: FiAward,
    color: "bg-green-100 text-green-600",
    liens: [
      {
        titre: "France Compétences - RNCP37275",
        url: "https://www.francecompetences.fr/recherche/rncp/37275/",
      },
      {
        titre: "Arrêté du 7 décembre 2022",
        url: "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000046751421",
      },
      {
        titre: "Les titres professionnels",
        url: "https://travail-emploi.gouv.fr/les-titres-professionnels",
      },
    ],
  },
  {
    title: "VAE : comprendre et faire les démarches",
    icon: FiFileText,
    color: "bg-purple-100 text-purple-600",
    liens: [
      {
        titre: "France VAE - Portail officiel",
        url: "https://vae.gouv.fr/",
      },
      {
        titre: "Ministère du Travail - La VAE",
        url: "https://travail-emploi.gouv.fr/la-validation-des-acquis-de-lexperience-vae",
      },
      {
        titre: "Service-Public - Démarches VAE",
        url: "https://www.service-public.fr/particuliers/vosdroits/F2401",
      },
    ],
  },
  {
    title: "CPF & Financements",
    icon: FiCreditCard,
    color: "bg-orange-100 text-orange-600",
    liens: [
      {
        titre: "Mon Compte Formation",
        url: "https://www.moncompteformation.gouv.fr/espace-public/inscription-connexion",
      },
      {
        titre: "Service-Public - Mon compte formation",
        url: "https://www.service-public.fr/particuliers/vosdroits/R46472",
      },
      {
        titre: "France Travail - CPF",
        url: "https://www.francetravail.fr/candidat/en-formation/mes-aides-financieres/le-compte-personnel-de-formation.html",
      },
    ],
  },
];

const faqItems = [
  {
    question:
      "Qu'est-ce que le titre professionnel Formateur Professionnel d'Adultes (FPA) ?",
    answer:
      "Le titre FPA (RNCP37275) est une certification de niveau 5 (Bac+2) délivrée par le Ministère du Travail. Il atteste des compétences nécessaires pour concevoir, animer et évaluer des actions de formation auprès d'un public adulte. C'est la référence nationale pour exercer le métier de formateur.",
  },
  {
    question:
      "Faut-il obligatoirement le titre FPA pour exercer en tant que formateur ?",
    answer:
      "Non, à ce jour aucun texte de loi n'impose de détenir le RNCP37275 pour former des adultes. Cependant, le marché évolue : les exigences Qualiopi, les attentes des financeurs (CPF, OPCO, France Travail) et le renforcement des contrôles rendent ce titre de plus en plus incontournable pour sécuriser son activité.",
  },
  {
    question: "Quels sont les prérequis pour accéder à la formation ?",
    answer:
      "Les prérequis varient selon le parcours choisi. De manière générale, il faut : un niveau de français suffisant (oral et écrit), une maîtrise des outils numériques de base, une expertise métier à transmettre et un projet professionnel défini. Pour la VAE, une expérience significative en formation est également requise.",
  },
  {
    question: "Comment financer ma formation ?",
    answer:
      "Nos formations sont 100% finançables dans la limite de vos droits. Plusieurs dispositifs existent : le CPF (Compte Personnel de Formation), les aides France Travail pour les demandeurs d'emploi, le financement OPCO/FAF pour les salariés, ou encore le financement personnel avec possibilité d'échelonnement. Notre équipe réalise une étude personnalisée de votre dossier.",
  },
  {
    question:
      "Quelle est la différence entre la VAE et la formation classique ?",
    answer:
      "La VAE (Validation des Acquis de l'Expérience) permet d'obtenir le titre FPA en faisant reconnaître votre expérience professionnelle existante, sans suivre l'intégralité d'un parcours de formation. Elle s'adresse aux personnes ayant déjà une pratique significative de la formation. La formation classique (sessions longues, université d'été) est un parcours complet d'apprentissage adapté à ceux qui souhaitent acquérir ou consolider les compétences du métier.",
  },
  {
    question: "Qu'est-ce que le Pack Expert ?",
    answer:
      "Le Pack Expert combine l'accompagnement VAE pour le titre FPA avec une certification complémentaire en prise de parole en public. À partir de 4 000€, vous obtenez deux certifications et les examens sont inclus dans le prix. C'est une double compétence rare et très valorisée sur le marché.",
  },
  {
    question: "Combien de temps dure la formation ?",
    answer:
      "La durée varie selon le parcours : l'Université d'été propose une formation intensive de 102 heures, les Sessions Longues (septembre et janvier) s'étalent sur 144 heures, et l'accompagnement VAE représente en moyenne 24 heures de suivi personnalisé. Chaque parcours est conçu pour s'adapter à votre situation professionnelle.",
  },
  {
    question:
      "Est-ce que la formation se déroule en présentiel ou à distance ?",
    answer:
      "Nos formations combinent présentiel et distanciel selon les parcours. Les sessions en présentiel se déroulent dans nos locaux à Nancy. Le titre FPA prépare justement à animer en présentiel comme en distanciel, et nos méthodes pédagogiques reflètent cette double compétence.",
  },
  {
    question: "Qu'est-ce que Qualiopi et quel impact sur ma formation ?",
    answer:
      "Qualiopi est la certification qualité obligatoire depuis le 1er janvier 2022 pour tout organisme de formation souhaitant accéder aux financements publics et mutualisés (CPF, OPCO, etc.). Notre organisme est certifié Qualiopi, ce qui vous garantit une formation de qualité et vous permet de mobiliser l'ensemble des dispositifs de financement.",
  },
  {
    question: "Comment se déroule l'examen du titre FPA ?",
    answer:
      "L'examen du titre professionnel comprend une mise en situation professionnelle (animation d'une séquence de formation devant un jury), la présentation d'un dossier professionnel décrivant votre pratique, et un entretien avec le jury. Les frais de certification sont inclus dans le prix de nos formations.",
  },
];

const FaqItem = ({ item, isOpen, onToggle }) => (
  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between p-5 bg-white hover:bg-gray-50 transition-colors duration-200 text-left cursor-pointer border-none"
    >
      <span className="text-gray-900 font-medium pr-4">{item.question}</span>
      <SafeIcon
        icon={FiChevronDown}
        className={`h-5 w-5 text-gray-500 flex-shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
      />
    </button>
    {isOpen && (
      <div className="px-5 pb-5 bg-white">
        <p className="text-gray-600 leading-relaxed">{item.answer}</p>
      </div>
    )}
  </div>
);

const RessourcesPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pt-52 pb-20 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Centre de ressources
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Toutes les informations officielles et ressources utiles pour votre
            parcours de formation de formateur professionnel d'adultes.
          </p>
        </motion.div>

        {/* Nos derniers articles */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Nos derniers articles
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <Link
                key={index}
                to={article.link}
                className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300 block no-underline"
              >
                <div className="flex items-center text-gray-500 text-sm mb-3">
                  <SafeIcon icon={FiCalendar} className="h-4 w-4 mr-2" />
                  <span>{article.date}</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center text-blue-600 text-sm font-medium group-hover:text-blue-800 transition-colors duration-200">
                  Lire l'article
                  <SafeIcon
                    icon={FiArrowRight}
                    className="h-4 w-4 ml-1 transition-transform duration-200 group-hover:translate-x-1"
                  />
                </span>
              </Link>
            ))}
          </div>
        </motion.div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-12"></div>

        {/* Resource Categories - stacked vertically */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-8"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Liens et ressources utiles
          </h2>
        </motion.div>

        <div className="space-y-8">
          {categories.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className={`${category.color} p-3 rounded-lg`}>
                  <SafeIcon icon={category.icon} className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {category.title}
                </h3>
              </div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {category.liens.map((lien, idx) => (
                  <a
                    key={idx}
                    href={lien.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-between p-3 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200 group"
                  >
                    <span className="text-gray-700 group-hover:text-blue-600">
                      {lien.titre}
                    </span>
                    <SafeIcon
                      icon={FiExternalLink}
                      className="h-4 w-4 text-gray-400 group-hover:text-blue-600 flex-shrink-0 ml-2"
                    />
                  </a>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Back to home link */}
        <div className="text-center pt-12">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RessourcesPage;
